/**
 * Free plan preview page – Navbar + ArtistFreeProfile + Footer.
 */

import React from "react";
import { Navbar } from "@/templates/Navbar";
import { Footer } from "@/templates/Footer";
import ArtistFreeProfile from "./Free/ArtistFreeProfile";

export interface FreePreviewProps {
  isMobile?: boolean;
}

export default function FreePreview({ isMobile = false }: FreePreviewProps) {
  return (
    <div className="text-white">
      {/* <Navbar /> */}
      <ArtistFreeProfile isMobile={isMobile} />
      <Footer />
    </div>
  );
}
